<template>
  <Index />
</template>
<script route="/spu/list">
  import Index from './index.jsx'
  export default {
    components: {Index}
    
  }
</script>